import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { Issue } from '../../IssueTrackerContext/types'
import { IssueStatus, Permission } from 'shared'
import { useCreateIssueCommentMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useIssueTrackerContext } from '../../IssueTrackerContext'
import { HelpMessage } from 'utils/constants'

export function useExpand(): ExpandOptions<Issue> {
  const help = HelpMessage.Issues.IssueTracker
  const { relations, edit } = useIssueTrackerContext()
  const [create] = useCreateIssueCommentMutation({
    ...DefaultMutationHookOptions,
    onCompleted: () => relations.refetch(),
  })
  return {
    render: ({
      id,
      comments,
      deleted,
      statusId,
      customFields,
      submittedDate,
      responseDate,
      dispositionDate,
      closedDate,
      payItems,
    }) => ({
      comments: {
        loading: relations.loading,
        comments,
        onSave: async (text) => {
          await create({ variables: { input: { issueId: id, text } } })
        },
        permission: Permission.CommentOnIssue,
      },
      customFields: {
        customFields,
        recordInactive: deleted,
        alreadyDisabled:
          statusId === IssueStatus.Closed.id
            ? { why: 'invalid status', statusName: IssueStatus.Closed.name }
            : false,
        booleanValueOptions: {
          onCheck: (input) =>
            edit({ id, customFields: { booleanInputs: [input] } }),
        },
        listValueOptions: {
          onCheck: (input) =>
            edit({ id, customFields: { listInputs: { checkboxes: [input] } } }),
        },
      },
      additionalInfo: [
        {
          type: 'date',
          date: submittedDate,
          label: 'Submitted Date',
          help: help.SubmittedDate,
          format: 'datetime',
        },
        {
          type: 'date',
          date: responseDate,
          label: 'Response Date',
          help: help.ResponseDate,
          format: 'datetime',
        },
        {
          type: 'date',
          date: dispositionDate,
          label: 'Disposition Date',
          help: help.DispositionDate,
          format: 'datetime',
        },
        {
          type: 'date',
          date: closedDate,
          label: 'Closed Date',
          help: help.ClosedDate,
          format: 'datetime',
        },
        {
          type: 'payItems',
          object: 'Issue',
          payItems,
          loading: relations.loading,
        },
      ],
    }),
  }
}
